import { FunctionsFetchError, FunctionsHttpError, FunctionsRelayError } from "@supabase/supabase-js"

export const getFunctionsErrorMessage = async (error: unknown, fallback = "Request failed") => {
  console.log("getFunctionsErrorMessage", error)
  if (error instanceof FunctionsHttpError) {
    const errorObj = await error.context.json()

    return errorObj.error
  } else if (error instanceof FunctionsRelayError) {
    return error.message
  } else if (error instanceof FunctionsFetchError) {
    return error.message
  }

  return fallback
}
